export default {
  namespaced: true,
  state: {
    isLoading: false,
    isAlerts: [],
  },
  mutations: {
    SET_IS_LOADING(state) {
      state.isLoading = !state.isLoading;
    },
    SET_IS_ALERT(state, value) {
      state.isAlerts.push(value);
    },
  },
  actions: {
    removeAlerts({ state }) {
      if (state.isAlerts.length > 0) {
        setTimeout(() => {
          state.isAlerts.shift();
        }, 1200);
      }
    },
  },
  getters: {
    countAlerts(state) {
      return state.isAlerts ? state.isAlerts.length : 0;
    },
  },
};
